import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Globals } from '../../../../globals';
import { ARService } from '../../ar.service';
import { dataARClaim, dataPatient, enumValidValueItem } from '../../_models/ar.models';
import {ActivatedRoute, Router} from '@angular/router';
import {DataARClaimListModel} from '../../models/data-ar-claim-list';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ReportViewerDialogComponent} from '../../../reports/report-viewer-dialog/report-viewer-dialog.component';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {DataARClaimModel} from '../../../../models/accountsReceivable/data-ar-claim.model';
import {ClaimViewComponent} from '../claim-view/claim-view.component';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ClaimStatusEnum} from '../../../../models/enum/claim-status.enum';
import {ValidationLogItem} from '../../models/ValidationLogItem.model';
import {ClaimValidationDetailComponent} from '../claim-validation-detail/claim-validation-detail.component';
import {ClaimMethodEnum} from '../../../../models/enum/notification/claim-method.enum';
import {ClaimLogComponent} from '../claim-log/claim-log.component';
import {NotesService} from "../../../../services/notes.service";
import {TdoNoteQueryModel} from "../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model";
import {NoteCategoryEnum} from "../../../../models/enum/note-category.enum";
import {NoteTypeEnum} from "../../../../models/enum/note-type.enum";
import {Subscription} from "rxjs";
import {normalizeFileReplacements} from "@angular-devkit/build-angular/src/utils";
import {InsuranceRtbDialogComponent} from '../../../insurance/insurance-rtb-dialog/insurance-rtb-dialog.component';
import {ClaimStatusDxDialogComponent} from '../claim-status-dx-dialog/claim-status-dx-dialog.component';

@Component({
  selector: 'app-claim-management',
  templateUrl: './claim-management.component.html',
  styleUrls: ['./claim-management.component.css']
})
export class ClaimManagementComponent implements OnInit {
  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

  LOCID: number;
  isLoading: boolean = true;
  PatientCaseId: string = '';
  PatientId: string = '';
  dxResponse: any;
  enumClaimStatusFilter: string = null;
  ClaimNumber: number = null;
  selectedClaim: DataARClaimListModel;

  dataClaims: DataARClaimListModel[] = [];
  dataClaimsMaster: DataARClaimListModel[] = [];
  dataPatients: dataPatient[] = [];
  claimTypes: enumValidValueItem[] = [];
  claimStatuses: enumValidValueItem[] = [];
  claimMethods: enumValidValueItem[] = [];

  enumClaimStatusCancelled: string = ClaimStatusEnum.Canceled;
  enumClaimStatusPendingReview: string = ClaimStatusEnum.PendingReview;
  enumClaimStatusReadyToSend: string = ClaimStatusEnum.ReviewedReadyToSend;
  enumClaimStatusClosed: string = ClaimStatusEnum.Closed;
  enumClaimStatusSent: string = ClaimStatusEnum.Sent;

  enumClaimCheckStatusIDNotChecked: string = '00000208-1000-0000-0000-000000000001';
  enumClaimCheckStatusIDProblem: string = '00000208-1000-0000-0000-000000000002';
  enumClaimCheckStatusIDPass: string = '00000208-1000-0000-0000-000000000003';

  private sub: Subscription;

  searchPredicate: (data: any, filter: string) => boolean;

  constructor(
    private globals: Globals,
    private arService: ARService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private notesService: NotesService,
    private route: ActivatedRoute,
  ) {
    this.searchPredicate = (data: DataARClaimListModel, filter: string) => {
      if ((!data.PatientFirstName ? '' : data.PatientFirstName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.PatientLastName ? '' : data.PatientLastName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.DoctorFullName ? '' : data.DoctorFullName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.PatientInsuranceName ? '' : data.PatientInsuranceName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.ClaimType ? '' : data.ClaimType).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.ClaimStatus ? '' : data.ClaimStatus).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!data.TDOClaimNumber ? 0 : data.TDOClaimNumber).toString().includes(filter)) {
        return true;
      }
      else {
        return false;
      }

    };
  }

  resetNotesFilter(objectId:string =''){
    const model = new TdoNoteQueryModel();
    model.parentObjectName = 'dataARClaims';
    model.objectId = objectId;
    model.patientId = this.globals.currentPatientId;
    model.categoryEnumId = NoteCategoryEnum.Claim;
    model.typeEnumId = NoteTypeEnum.Patient;
    this.notesService.changeNoteQuery(model);
  }

  async ngOnInit() {

    this.LOCID = parseInt(localStorage.getItem('LOCID'));
    this.PatientCaseId = this.globals.currentPatientCaseId;
    this.PatientId = this.globals.currentPatientId;
    this.ClaimNumber = parseInt(localStorage.getItem('TDOClaimNumber'));

    this.resetNotesFilter('');

    const promises: any[] = [
      this.arService.getAllClaims().toPromise(),
      this.arService.getEnumStatusesForClaims().toPromise(),
      this.arService.getEnumMethodsForClaims().toPromise()
    ];

    this.isLoading = true;

    const results: any[] = await Promise.all(promises);
    this.dataClaimsMaster = results[0];
    this.dataClaims = results[0];
    this.claimStatuses = results[1];
    this.claimMethods = results[2];

    this.isLoading = false;

    if(this.ClaimNumber) {
      localStorage.removeItem('TDOClaimNumber');
      this.dataClaims = this.dataClaimsMaster.filter(a => a.TDOClaimNumber === this.ClaimNumber);
    }

     /* const events: TdoTableSelectionEvent = new TdoTableSelectionEvent();
      event.
      events.model = this.selectedClaim;
      events.isSelected = true;
      this.onRowSelected(events);*/
  }

  getPatientsFromPatientIds(patientIds: string[]) {
    return this.arService.getPatientsFromIds(patientIds).toPromise();
  }

  getInitVariables() {
    const promise = new Promise(async (resolve, reject) => {

      const patientCaseId = this.globals.currentPatientSelectedCaseItem.PatientCaseId;

      const promises = [
        this.getAppointmentInformation(patientCaseId),
      ];

      try {
        const results: any[] = await Promise.all(promises);
        const appointment = results[0];
        this.PatientId = appointment.PatientId;
        resolve(true);
      } catch (err) {
        reject(err);
      }

    });
    return promise;
  }

  getAppointmentInformation(PatientCaseId: string) {
    return this.arService.getAppointmentInformation(PatientCaseId).toPromise();
  }

  getAllClaims(): Promise<DataARClaimListModel[]> {
    return this.arService.getAllClaims().toPromise<DataARClaimListModel[]>();
  }

  navigateTo(path) {
    this.router.navigate([path]);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    /*if (event.isMultiSelection) {
      const ledgerItem: DataARLedgerListModel = event.model;
      ledgerItem.DATA_SELECTED = true;
    }*/
    console.log("Claims onRowSelected", event);
    this.resetNotesFilter(event.isSelected? event.model.ARClaimID : '');
    const claimModel = this.dataClaims.find(p => p === event.model);
    if (claimModel) {
      claimModel.DATA_SELECTED = event.isSelected;
    }
  }

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }

    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  showADAFormDialog(item: DataARClaimListModel) {

    const config = new MatDialogConfig();
    config.width = '1300px';
    config.height = '900px';
    config.data = {
      patientId: 'testing',
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ReportViewerDialogComponent, config);
  }

  openClaim(item: DataARClaimListModel) {

    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '675px';
    config.data = {
      ARClaimID: item.ARClaimID,
      enumClaimStatusID: item.enumClaimStatusID,
      enumClaimCheckStatusID: item.enumClaimCheckStatusID,
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ClaimViewComponent, config);

    reportViewer.afterClosed().subscribe(result => {
      this.arService.getAllClaims()
        .subscribe(response => {
            this.dataClaims = response;
            this.tdoTable.dataSource = this.dataClaims;
            this.tdoTable.updateData();
          },
          err => {
            // show error
          });
    }, err => {
      // reject(err);
    });
  }

  testSend() {
    this.getDXClaimSubmission();
  }

  getDXClaimSubmission() {
    return this.arService.getDXClaimSubmission().toPromise();
  }

  sendClaims() {

    // update status to sending ...
    let count = 0;
    this.dataClaims.forEach(a => {
      // if ready to send, set status to sending
      if (a.enumClaimStatusID === ClaimStatusEnum.ReviewedReadyToSend && a.enumClaimMethodID === ClaimMethodEnum.APIDX) {

        a.enumClaimStatusID = ClaimStatusEnum.Sending;
        a.ClaimStatus = 'Sending...';
        count++;

        // also update master view
        this.dataClaimsMaster.forEach(b => {
          if (a.ARClaimID === b.ARClaimID) {
            b.enumClaimStatusID = ClaimStatusEnum.Sending;
            b.ClaimStatus = 'Sending...';

            if (b.enumClaimMethodID === ClaimMethodEnum.ADAForm) {
              b.SentDate = new Date();
            }
          }
        });
      }
    });

    // send claims to dental exchange
    this.arService.sendClaimsToDentalExchange()
      .subscribe(resp => {
          this.isLoading = false;

          // if we get proper response, update statuses
          if (resp != null && resp.length > 0) {
            resp.forEach(a => {
              this.dataClaims.forEach(b => {
                if (b.ARClaimID === a.ARClaimID) {
                  b.enumClaimStatusID = a.enumClaimStatusID;
                }
              });
            });
          }
          else {
            // set "sending" claims to error status
            this.setClaimsToSendingError();
          }
        },
        err => {
          // show error
          // set "sending" claims to error status
          this.setClaimsToSendingError();
        });


    // // save status change
    // this.arService.saveClaimCheckStatus(a)
    //   .subscribe(checkResponse => {
    //       this.isLoading = false;
    //     },
    //     err => {
    //       // show error
    //     });

    // // statuses changed?
    // if (this.dataClaims.length > 0 && count === 0) {
    //   // popup window
    //   this.createMessage('Claims need a status of Reviewed/Ready To Send in order to send them.', 'Error');
    // }
    // else if (count > 0) {
    //   // update view
    //   this.tdoTable.dataSource = this.dataClaims;
    //   this.tdoTable.updateData();
    // }
  }

  setClaimsToSendingError() {
    this.dataClaims.forEach(a => {
      // if sending, set status to sending error
      if (a.enumClaimStatusID === ClaimStatusEnum.Sending && a.enumClaimMethodID === ClaimMethodEnum.APIDX) {
        a.enumClaimStatusID = ClaimStatusEnum.SendError;

        // also update master view
        this.dataClaimsMaster.forEach(b => {
          if (a.ARClaimID === b.ARClaimID) {
            b.enumClaimStatusID = ClaimStatusEnum.SendError;
          }
        });
      }
    });
  }

  checkClaim(claim: DataARClaimListModel) {
    const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === claim.ARClaimID);

    if (claim.enumClaimMethodID && claim.enumClaimMethodID === ClaimMethodEnum.APIDX) {
      this.arService.getDXClaimValidationResult(claim.ARClaimID)
        .subscribe(response => {
            // read response
            this.dxResponse = response;
            this.isLoading = false;

            if (response.ErrorStatus === 0) {
              // validation appears to have succeeded
              this.createMessage('Internal Validation Successful', response);

              // update enumClaimCheckStatusID status to passed
              claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
              claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
            }
            else if (response.ErrorStatus === 100) {
              // internal validation succeeded, but DX validation failed
              this.createMessage('Internal validation succeeded, but DXC validation failed. See log for details.', 'Close');

              // update enumClaimCheckStatusID status to passed
              claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
              claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
            }
            else
            {
              // show our claim validation window
              this.openClaimValidationDetail(response.ValidationLogItems);

              // update enumClaimCheckStatusID status to problem
              claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
              claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
            }

            // update enumClaimCheckStatus in DB
            const claimToUpdate = new DataARClaimModel();
            claimToUpdate.ARClaimID = claim.ARClaimID;
            claimToUpdate.enumClaimCheckStatusID = claim.enumClaimCheckStatusID;
            this.arService.saveClaimCheckStatus(claimToUpdate)
              .subscribe(checkResponse => {
                  this.isLoading = false;
                },
                err => {
                  // show error
                });

            // this.closeRef();
          },
          err => {
            // show error
          });
    }
    else {
      // claim to be sent via ada form, don't run dx api
      this.arService.getInternalClaimValidationResult(claim.ARClaimID)
        .subscribe(response => {
            // read response
            this.dxResponse = response;
            this.isLoading = false;

            if (response.ErrorStatus === 0) {
              // validation appears to have succeeded
              this.createMessage('Internal Validation Successful', response);

              // update enumClaimCheckStatusID status to passed
              claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
              claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
            }
            else
            {
              // show our claim validation window
              this.openClaimValidationDetail(response.ValidationLogItems);

              // update enumClaimCheckStatusID status to problem
              claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
              claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
            }

            // update enumClaimCheckStatus in DB
            const claimToUpdate = new DataARClaimModel();
            claimToUpdate.ARClaimID = claim.ARClaimID;
            claimToUpdate.enumClaimCheckStatusID = claim.enumClaimCheckStatusID;
            this.arService.saveClaimCheckStatus(claimToUpdate)
              .subscribe(checkResponse => {
                  this.isLoading = false;
                },
                err => {
                  // show error
                });
          },
          err => {
            // show error
          });
    }
  }

  openClaimValidationDetail(items: ValidationLogItem[]) {

    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '675px';
    config.data = {
      ValidationLogItems: items,
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ClaimValidationDetailComponent, config);

    reportViewer.afterClosed().subscribe(result => {
      // no action
    }, err => {
      // reject(err);
    });
  }

  saveClaimMethod(ARClaimID: string, event) {
    // save claim method
    const claim = this.dataClaims.filter(a => a.ARClaimID === ARClaimID);
    const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === ARClaimID);

    if (claim.length === 1) {
      claim[0].enumClaimMethodID = event.value;
      claimMaster[0].enumClaimMethodID = event.value;

      this.arService.saveClaimMethod(claim[0])
        .subscribe(response => {
            if (response) {
              // response is good
            }
          },
          err => {
            // show error
            this.createMessage('Problem saving claim method.', 'Error');
          });
    }
    else {
      // show error
      this.createMessage('Problem saving claim method.', 'Error');
    }
  }

  saveClaimStatus(ARClaimID: string, event) {
    // save claim status
    const claim = this.dataClaims.filter(a => a.ARClaimID === ARClaimID);
    const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === ARClaimID);

    if (claim.length === 1) {
      claim[0].enumClaimStatusID = event.value;
      claimMaster[0].enumClaimStatusID = event.value;

      if (event.value === this.enumClaimStatusClosed) {
        claim[0].ClosedDate = new Date();
        claimMaster[0].ClosedDate = new Date();
      }

      this.arService.saveClaimStatus(claim[0])
        .subscribe(response => {
            if (response) {
              // response is good
            }
          },
          err => {
            // show error
            this.createMessage('Problem saving claim status.', 'Error');
          });
    }
    else {
      // show error
      this.createMessage('Problem saving claim status.', 'Error');
    }
  }

  filterByClaimStatus(event) {
    if (event.value) {
      this.dataClaims = this.dataClaimsMaster.filter(a => a.enumClaimStatusID === event.value);
      this.tdoTable.dataSource = this.dataClaims;
      this.tdoTable.updateData();
    }
  }

  showClaimLog(item: DataARClaimListModel) {
    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '590px';
    config.data = {
      ARClaimID: item.ARClaimID,
    };
    config.panelClass = 'dialog';

    const logViewer = this.dialog.open(ClaimLogComponent, config);

    logViewer.afterClosed().subscribe(result => {
    }, err => {
    });
  }

  openDXStatus(ARClaimID: string) {
    this.launchClaimStatusResponseViewer(ARClaimID);
  }

  launchClaimStatusResponseViewer(ARClaimId: string) {

    const config = new MatDialogConfig();
    config.width = '617px';
    config.height = '745px';
    config.data = {
      ARClaimID: ARClaimId,
    };
    config.panelClass = 'dialog';

    const rtbViewer = this.dialog.open(ClaimStatusDxDialogComponent, config);
  }

  protected readonly ClaimMethodEnum = ClaimMethodEnum;
}
